import type { ContextMenuItemType, ObjectTreeNode, SubMenuItemType } from '@core/core/types'
import type { Prettify } from 'common/types'
import type { RefObject } from 'react'

export type ContextSubMenuItemType = ContextMenuItemType | SubMenuItemType

export type OnChangeStateChecked = (object: {
  e: undefined
  checked: boolean
  indeterminateState: boolean
}) => void

export type ChangeMenuVisibilityFuncType = (
  ref: RefObject<HTMLButtonElement>,
  objectTreeNode: ObjectTreeNode,
) => void

export type ToBinFuncType = (elementId: string, name: string) => void

type ShowGeoDbImportSidebarFuncType = () => void

export type ObjectTreeNodeLabel = Prettify<
  Pick<ObjectTreeNode, 'name'> &
    Partial<Pick<ObjectTreeNode, 'uid'>> &
    Partial<Pick<ObjectTreeNode, 'elementType' | 'state'>>
>

export type ProjectObjectsPropsType = {
  objectTreeNode?: ObjectTreeNode
  showObjectsProperties: boolean
  showGeoDbImportSidebar: ShowGeoDbImportSidebarFuncType
  setObjectTreeNode: (objectTreeNode: ObjectTreeNode) => void
  getActionFromItem: GetActionFromItemFunc
}
export type GetActionFromItemFunc = (type: ContextSubMenuItemType) => void | Promise<void>

export enum SurveyType {
  TwoD = '2D',
  ThreeD = '3D',
}
export enum SurveyChoiceGroupItems {
  New = 'Создать новую съемку',
  Existent = 'Выбрать съемку для загрузки',
}

export type HandleDownloadFilesFuncType = (objectTreeNode?: ObjectTreeNode) => Promise<void>
